import classNames from 'classnames';
import { observer } from 'mobx-react';

import { useDelayedToggle } from '../../../hooks/useDelayedToggle';

import styles from './interactiveAnimationFTUE.module.scss';
import { InteractiveAnimationFTUERive } from './InteractiveAnimationFTUERive';
import { getFtueViewType } from './riveFileConfig';
import { useInteractiveAnimationFTUE } from './useInteractiveAnimationFTUE';

export const InteractiveAnimationFTUEView = observer(() => {
  const { terminateOnboardingTourGuideFlow, onGuideEvent, onGuideRestored, showOnboarding, savedStep } =
    useInteractiveAnimationFTUE();

  const isViewShowed = useDelayedToggle(showOnboarding, 200);

  if (!isViewShowed) {
    return null;
  }

  const viewType = getFtueViewType();

  return (
    <div
      className={classNames({
        [styles.overlay]: true,
        [styles.fadeIn]: showOnboarding,
        [styles.fadeOut]: !showOnboarding,
      })}
    >
      <InteractiveAnimationFTUERive
        savedStep={savedStep || null}
        terminateTourGuideFlow={terminateOnboardingTourGuideFlow}
        viewType={viewType}
        onGuideEvent={onGuideEvent}
        onGuideRestored={onGuideRestored}
      />
    </div>
  );
});
